import { render, staticRenderFns } from "./RegisterField.vue?vue&type=template&id=4255434b&scoped=true&"
import script from "./RegisterField.vue?vue&type=script&lang=js&"
export * from "./RegisterField.vue?vue&type=script&lang=js&"
import style0 from "./RegisterField.vue?vue&type=style&index=0&id=4255434b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4255434b",
  null
  
)

export default component.exports